export const BATCH_THROTTLE_DURATION_MS = 300;
//# sourceMappingURL=constants.js.map